<template>
<div class="special-board">
    <!-- <div class="title">西安智慧润滑大数据特种油配送看板</div> -->
    <div class="table-container">
        <el-table :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle" :data="tableData" border tooltip-effect="dark" style="width: 100%">
            <el-table-column align="center" prop="number" label="序号" width="180">
            </el-table-column>
            <el-table-column align="center" prop="transformer_manufacturers" label="变压器厂家" width="180">
            </el-table-column>
            <el-table-column align="center" prop="project_name" label="项目名称" width="180">
            </el-table-column>
            <el-table-column align="center" prop="contact_form_date" label="联络单日期" width="180">
            </el-table-column>
            <el-table-column align="center" prop="oil_distribution_location" label="配油地点" width="180">
            </el-table-column>
            <el-table-column align="center" prop="voltage_grade" label="电压等级" width="180">
            </el-table-column>
            <el-table-column align="center" prop="work_number" label="工作号" width="180">
            </el-table-column>
            <el-table-column align="center" prop="planned_volume" label="计划量" width="180">
            </el-table-column>
            <el-table-column align="center" prop="oil_model" label="油型号" width="180">
            </el-table-column>
            <el-table-column align="center" prop="oil_distribution_quantity" label="配油数量" width="180">
            </el-table-column>
            <el-table-column align="center" prop="planned_arrival_time" label="计划到达时间" width="180">
            </el-table-column>
            <el-table-column align="center" prop="on_site_contact_person" label="现场联系人" width="180">
            </el-table-column>
            <el-table-column align="center" prop="contact_telephone" label="联系人电话" width="180">
            </el-table-column>
            <el-table-column align="center" prop="distributor_name" label="配送商名称" width="180">
            </el-table-column>
            <el-table-column align="center" prop="planned_depot_location" label="计划出库地点" width="180">
            </el-table-column>
            <el-table-column align="center" prop="sales_representative_responsible" label="负责销售代表" width="180">
            </el-table-column>
            <el-table-column align="center" prop="oil_depot_time" label="油品出库时间" width="180">
            </el-table-column>
            <el-table-column align="center" prop="location_site_time" label="地点现场时间" width="180">
            </el-table-column>
             <el-table-column align="center" prop="return_time" label="回单时间" width="180">
            </el-table-column>
             <el-table-column align="center" prop="actual_quantity" label="实收数量" width="180">
            </el-table-column>
             <el-table-column align="center" prop="service_charge" label="服务费" width="180">
            </el-table-column>
             <el-table-column align="center" prop="freight" label="运费" width="180">
            </el-table-column>
             <el-table-column align="center" prop="car_parking_fee" label="压车费" width="180">
            </el-table-column>
             <el-table-column align="center" prop="other_charges" label="其他费" width="180">
            </el-table-column>
             <el-table-column align="center" prop="haul_distance" label="运距" width="180">
            </el-table-column>
             <el-table-column align="center" prop="service_price" label="服务价" width="180">
            </el-table-column>
            <el-table-column align="center" prop="freight_rate" label="运价" width="180">
            </el-table-column>
            <el-table-column align="center" prop="declaration_settlement_time" label="申报结算时间" width="180">
            </el-table-column>
            <el-table-column align="center" prop="billing_time" label="开票时间" width="180">
            </el-table-column>
            <el-table-column align="center" prop="invoice_number" label="发票号码" width="180">
            </el-table-column>
            <el-table-column align="center" prop="invoice_handover_time" label="发票交接时间" width="180">
            </el-table-column>
            <el-table-column align="center" prop="ticket_holder" label="接票人" width="180">
            </el-table-column>
            <el-table-column align="center" prop="settlement_amount" label="结算量" width="180">
            </el-table-column>
            <el-table-column align="center" prop="cost_status" label="费用状态" width="180">
            </el-table-column>
            <el-table-column align="center" prop="remarks" label="备注" width="180">
            </el-table-column>
        </el-table>
    </div>
    <div class="echart-container">
        <div class="top">
            <div class="status"><span class="squar color-skyblue"></span>订单量</div>
            <div class="status"><span class="squar color-orange"></span>结算量</div>
            <div class="status"><span class="squar color-blue"></span>待执行量</div>
        </div>
        <div id="bottom"></div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            tableData: [],
            option: {
                title: {
                    text: '',
                    x: 'center',
                    y: 'top'
                },
                color: ['#00A4E1', '#FE5500', '#3E2EA2'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '0',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    splitLine:{show: false},
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        interval: 0,
                        // rotate: 40
                    },
                    data: []
                }],
                yAxis: [{
                    type: 'value',
                    min: 0,
                    // max: 100,
                    splitLine:{show: false},
                    name: '/吨'
                }],
                series: [{
                        name: '订单量',
                        type: 'bar',
                        barGap: 0,
                        label: {
                            normal: {
                                position: 'top'
                            }
                        },
                        data: []
                    },
                    {
                        name: '已发货',
                        type: 'bar',
                        label: {
                            normal: {
                                position: 'top'
                            }
                        },
                        data: []
                    },
                    {
                        name: '待执行量',
                        type: 'bar',
                        label: {
                            normal: {
                                position: 'top'
                            }
                        },
                        data: []
                    }
                ]
            },
            areaArr: [],
            orderNum: [],
            complete: [],
            todo: []
        }
    },
    created() {
        this.$nextTick(() => {
            this.axios.get('https://xarh.sprucesmart.com/api/v2/special_board')
                .then(res => {
                    console.log(res)
                    this.tableData = res.data.excel_data;
                    res.data.board_data.forEach((item, index) => {
                        this.areaArr.push(item.project_name);
                        this.complete.push(item.shipped);
                        this.orderNum.push(item.settled);
                        this.todo.push(item.unshipped);
                    });
                    this.option.xAxis[0].data = this.areaArr;
                    this.option.series[0].data = this.orderNum;
                    this.option.series[1].data = this.complete;
                    this.option.series[2].data = this.todo;
                    var myChart = this.$echarts.init(document.getElementById('bottom'));
                    myChart.setOption(this.option)
                })
        })
    },
    methods: {
        changeTableHeaderStyle({row, rowIndex}) {
            return "color: white; background-color: #3E2EA2;";
        },
        changeTableStyle ({row, column, rowIndex, columnIndex}) {
            if(columnIndex == 5) {
                if(row.status_num == -1) {
                    return 'color: #FF3333;'
                }
                else if(row.status_num == 0) {
                    return 'color: #29bd7f;'
                }
                else if(row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
    }
}
</script>

<style scoped>
.special-board {

}
.title {
    width: 100%;
    line-height: 60px;
    font-size: 24px;
    color: #000;
    text-align: center;
}
.table-container {
    width: 1200px;
    margin: 0 auto;
}
.echart-container {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
    padding-top: 15px;
}
.top {
    position: absolute;
    top: 15px;
    left: 50%;
    transform: translate(-50%, 0);
    margin: 0 auto;
}
.status {
    display: inline-block;
    margin-right: 20px;
    height: 18px;
    line-height: 18px;
}
.squar {
    display: inline-block;
    width: 18px;
    height: 18px;
    position: relative;
    top: 3px;
    margin-right: 8px;
}
.color-skyblue {
    background-color: #00A4E1;
}
.color-orange {
    background-color: #FE5500;
}
.color-blue {
    background-color: #3E2EA2;
}
#bottom {
    width: 100%;
    height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataBoard/bigDataBoard/SpecialBoard.vue